import { observable, action, computed, makeObservable } from 'mobx';
import { Configuration } from 'nomst/Stores/Configuration/configuration';
import { Manager } from 'nomst/Stores/Decision/manager';
import { dataManagerFactory } from 'utils/MobxDataManager/singletons';

export class ManagerHeaderStore {
    private readonly _configuration: Configuration;

    @observable private _managers: Manager[];

    constructor(configuration: Configuration) {
        makeObservable(this);
        this._configuration = configuration;
    }

    @computed get managers(): Manager[] {
        return this._managers;
    }

    @computed get selectedManagersDirectReportsCount(): number {
        return this._managers.reduce((accumulator, manager) => accumulator + manager.directReportsCount, 0);
    }

    @action
    async fetchManagers(managerSourceIds: string[]): Promise<void> {
        const managers = await dataManagerFactory.getManagerDataManager().getManagers(
            this._configuration.masterAccountId,
            this._configuration.cycleId,
            managerSourceIds);

        this._managers = managers ? managers.map(manager => new Manager(manager, this._configuration)) : [];
    }
}